import $ from "jquery";

$(function initialize() {
    $.pjax.defaults.timeout = 3000;
    $.pjax.defaults.scrollTo = false;
});
